export class NativeStreamAggregationServing {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "copies",
            "baseName": "copies",
            "type": "number",
            "format": ""
        },
        {
            "name": "keySeparator",
            "baseName": "keySeparator",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationServing.attributeTypeMap;
    }
    constructor() {
    }
}
